const Title = ({ badge, children, fullWidth }) => {
    return (
        <div className="main-content__title">
            <span className="main-content__title--span" style={{ width: fullWidth }}>
                {children}
            </span>
            <div className="main-content__title-number">{badge && <span>( {badge} )</span>}</div>
        </div>
    );
};

export default Title;
